import classnames from 'classnames'
import { useDispatch, useSelector } from 'react-redux'
import { useOutletContext } from 'react-router-dom'
import { pluralize } from '../../../../utility/helperFunctions'
import { clearWaitlistActionSuccessMessage, selectAllEnrollmentsRosterData, selectWaitlist } from '../../../../reducers/programDashboardReducer'

import GolfersTable from './GolfersTable'
import WaitlistTable from './waitlist/WaitlistTable'
import SubmitButton from '../../../common/buttons/SubmitButton'
import SuccessModal from '../../../common/customModal/SuccessModal'

import { ReactComponent as InfoCircleIcon } from '../../../../assets/images/common/icons/info-circle-icon-outline.svg'
import { ReactComponent as GolferHalfIcon } from '../../../../assets/images/common/icons/golfer-half-icon.svg'
import { ReactComponent as CirclePlusIcon } from '../../../../assets/images/common/icons/circle-plus-icon.svg'
import { ReactComponent as FlagIcon } from '../../../../assets/images/common/icons/Flag.svg'

import classes from './EnrollmentsTab.module.scss'


const RosterTab = () => {
  const dispatch = useDispatch()
  const { onOpenAddStudentsModal, withAddStudentsAction, handleOpenWaitlistStudentsModal } = useOutletContext()

  const { program } = useSelector(state => state.programDashboard)
  const enrollments = useSelector(selectAllEnrollmentsRosterData)
  const waitlist = useSelector(selectWaitlist)
  const waitlistActionSuccessMessage = useSelector(state => state.programDashboard.waitlistActionSuccessMessage)

  return (
    <div className={classnames('d-flex row no-gutters', classes.rosterTab)}>
      <div className={classnames('d-flex flex-column', classes.enrollments, { 'col-xl-9': program.hasWaitlistEnabled })}>
        <div className={classnames('pl-4 py-3 d-flex align-items-center', classes.header)}>
          <span className={classes.userCount}>
            {`${enrollments.length}`}&nbsp;
            {`${program.golferLimit ? `/ ${program.golferLimit}` : ''}`}&nbsp;
            {program.golferLimit ? pluralize('Golfer', program.golferLimit) : pluralize('Golfer', enrollments.length)}
          </span>
          <InfoCircleIcon role='button' className={classnames('ml-2', classes.icon)} />
        </div>
        {enrollments.length === 0 ? (
          <div className={classnames('d-flex flex-column align-items-center mx-auto', classes.placeholder)}>
            <GolferHalfIcon className={classnames('mb-2', classes.icon)} />
            <h2 className={classes.title}>No Enrollments Yet</h2>
            {withAddStudentsAction ? (
              <SubmitButton
                buttonMessage='Add Students'
                onClick={onOpenAddStudentsModal}
              />
            ) : (
              <p className={classes.text}>Share this program with the students in your community!</p>
            )}
          </div>
        ) : (
          <GolfersTable program={program} enrollments={enrollments} />
        )}
      </div>
      {program.hasWaitlistEnabled && (
        <div className={classnames('d-flex p-4 flex-column col-lg-auto col-xl', classes.waitlist)}>
          <div className={classnames(classes.waitlistHeader)}>
            <h6 className='mb-0'>Waitlist ({waitlist.length})</h6>
            <button className={classes.addButton} onClick={handleOpenWaitlistStudentsModal}>
              <CirclePlusIcon />
            </button>
          </div>
          <SuccessModal
            isOpen={!!waitlistActionSuccessMessage}
            onClose={() => dispatch(clearWaitlistActionSuccessMessage())}
            title={waitlistActionSuccessMessage?.title}
            message={waitlistActionSuccessMessage?.message}
            buttonMessage='Close'
          />
          {waitlist.length === 0 ? (
            <div className={classnames('d-flex flex-column align-items-center text-center mx-auto', classes.waitlistPlaceholder)}>
              <FlagIcon className={classnames('mb-3', classes.waitlistEmptyIcon)} width={50} height={50} />
              <h5 className={classes.message}>No Students yet</h5>
              <p className={classes.waitlistPlaceholderText}>
                Waitlist is enabled, when class capacity is at limit students will be able to join the waitlist.
                You can add them to this class, or another.
              </p>
            </div>
          ) : (
            <WaitlistTable course={program} />
          )}
        </div>
      )}
    </div>
  )
}

export default RosterTab
